import React from "react";

import isIntuit from "Intuit/isIntuit";
import PropTypes from "prop-types";
import formatCurrency from "Utils/formatCurrency";

import BodyText from "Common/BodyText";
import { Div } from "Common/HTML";

import RangeBar from "./RangeBar";

import makeBem from "Utils/makeBem";

const bem = makeBem("PlanDetails");

const getBarColor = (value) => {
  if (value <= 20) {
    return "green";
  }
  if (value <= 40) {
    return "lightgreen";
  }
  if (value <= 60) {
    return "yellow";
  }
  if (value <= 80) {
    return "lightorange";
  }
  return "orange";
};

const RangeArrow = ({ percent, label }) => (
  <div className={bem("RangeArrowContainer")}>
    <div className={bem("RangeArrow")} style={{ left: `${percent}%` }}>
      <BodyText size="ns-twelve" className={bem("RangeArrowContents", isIntuit() ? "intuit" : null)}>
        {label}
      </BodyText>
    </div>
  </div>
);

type Props = {
  min: number;
  max: number;
  value: number;
};

export default function PlanTermRange({ min, max, value }: Props) {
  const valuePercentage = ((value - min) / (max - min)) * 100;
  const color = getBarColor(valuePercentage);

  return (
    <Div className="clearfix" mb={4}>
      <RangeArrow percent={valuePercentage} label={formatCurrency(value) || "$-"} />

      <RangeBar color={color} />
      <RangeBar color={color} />
      <RangeBar color={color} />
      <RangeBar color={color} />
      <RangeBar color={color} />
      <div className="pull-left">{formatCurrency(min) || "$-"}</div>
      <div className="float-right">{formatCurrency(max) || "$-"} </div>
    </Div>
  );
}

PlanTermRange.propTypes = {
  min: PropTypes.number,
  max: PropTypes.number,
  value: PropTypes.number,
};
